let mcSubmitted = false;

// Attach event listeners to the form
const form = document.querySelector('#mc-embedded-subscribe-form');
if (form) {
    form.addEventListener('submit', function (event) {
        mcSubmitted = true;
    });

    const emailInput = form.querySelector('.mc-field__email');
    emailInput && emailInput.addEventListener('change', () => {
        // We use setTimeout to get the latest state of the input data. Without it, we get old data
        setTimeout(() => {
            if (emailInput.getAttribute('aria-invalid') === 'true') {
                emailInput.setAttribute('aria-describedby', 'email-error-msg');
            } else {
                emailInput.removeAttribute('aria-describedby');
            }
        }, 0);
    })

    form.addEventListener('reset', function (event) {
        if (mcSubmitted) {
            // Hide the success message
            const successResponse = document.querySelector('#mce-success-response');
            if (successResponse) {
                successResponse.style.display = "none";
            }

            // Newsletter datalayer code
            let newsletterFormType = 'Newsletter';
            if (theme.settings.newsletterTemplate === 'true') {
                newsletterFormType = 'Newsletter SignupPage';
            }
            dataLayer.push({
                'event': 'gaEvent',
                'eventTrigger': 'Newsletter',
                'eventCategory': 'Form',
                'eventAction': 'Submit',
                'eventLabel': newsletterFormType,
                'eventValue': undefined
            });

            // Check if there is a thank you page link
            if (theme.settings.newsletterTemplate === 'true' && theme.settings.thankyou_page_url) {
                window.location.href = theme.settings.thankyou_page_url;
            } else {
                const thanksMessage = document.querySelector('#mc-thanks-msg');
                if (thanksMessage) {
                    thanksMessage.style.display = "block";
                }
            }
        }
    });
}
